import Footer from "./Footer";
import Header from "./Header";
import { Outlet } from "react-router-dom";
import PwaInstallPrompt from "../PwaInstallPrompt";

const Layout = () => {

    return (
        <>
            <Header />
            <PwaInstallPrompt />
            <main className="min-h-[44vh]">
                <Outlet />
            </main>
            <Footer />
        </>
    )
}

export default Layout
